import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'

export function TermsPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-[#FBF9F5]">
      {/* Header */}
      <div className="bg-white border-b border-[#E3DED2]">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 text-[#6E7582] hover:text-[#0F1C2E]"
          >
            <ArrowLeft className="w-4 h-4" />
            Back
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-4 py-12">
        <h1 className="text-3xl font-bold text-[#0F1C2E] mb-8">Terms of Service</h1>

        <div className="prose prose-blue max-w-none">
          <p className="text-[#6E7582] mb-8">
            Last updated: January 2026
          </p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">1. Acceptance of Terms</h2>
            <p className="text-[#6E7582] mb-4">
              By accessing or using the Drive Without Fear platform, you agree to be bound by these
              Terms of Service and all applicable laws and regulations. If you do not agree with any
              of these terms, you are prohibited from using this service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">2. Description of Service</h2>
            <p className="text-[#6E7582] mb-4">
              Drive Without Fear provides digital therapy tools and resources designed to help
              individuals manage driving anxiety and trauma. Our services include:
            </p>
            <ul className="list-disc pl-6 text-[#6E7582] mb-4 space-y-2">
              <li>Video-based therapeutic content</li>
              <li>Progress tracking tools</li>
              <li>Anxiety rating systems</li>
              <li>Support person linking functionality</li>
              <li>Voice memo recording capabilities</li>
            </ul>
            <p className="text-[#6E7582] mb-4">
              <strong>Important:</strong> This platform does not provide medical diagnosis or replace
              professional mental health treatment. Always consult with a qualified healthcare
              provider for medical advice.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">3. User Accounts</h2>
            <p className="text-[#6E7582] mb-4">
              You are responsible for maintaining the confidentiality of your account credentials
              and for all activities that occur under your account. You must immediately notify us
              of any unauthorized use of your account.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">4. Payment Terms</h2>
            <p className="text-[#6E7582] mb-4">
              The full program access is available for a one-time payment of EUR 250. This payment grants
              lifetime access to all program features. Payments are processed securely through Stripe.
            </p>
            <p className="text-[#6E7582] mb-4">
              We offer a 30-day money-back guarantee. If you are not satisfied with the program,
              contact us within 30 days of purchase for a full refund.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">5. Intellectual Property</h2>
            <p className="text-[#6E7582] mb-4">
              All content on this platform, including videos, text, graphics, and software, is the
              property of Drive Without Fear or its licensors and is protected by copyright and
              other intellectual property laws.
            </p>
            <p className="text-[#6E7582] mb-4">
              You may not copy, distribute, modify, or create derivative works from any content
              without explicit written permission.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">6. User Conduct</h2>
            <p className="text-[#6E7582] mb-4">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 text-[#6E7582] mb-4 space-y-2">
              <li>Use the service for any unlawful purpose</li>
              <li>Share your account credentials with others</li>
              <li>Attempt to gain unauthorized access to any part of the service</li>
              <li>Interfere with or disrupt the service</li>
              <li>Upload or transmit malicious code</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">7. Limitation of Liability</h2>
            <p className="text-[#6E7582] mb-4">
              Drive Without Fear is provided "as is" without warranties of any kind. We are not
              liable for any indirect, incidental, special, or consequential damages arising from
              your use of the service.
            </p>
            <p className="text-[#6E7582] mb-4">
              This platform is a supportive tool and does not replace professional medical treatment.
              If you are experiencing a mental health crisis, please contact emergency services or
              a crisis helpline immediately.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">8. Modifications</h2>
            <p className="text-[#6E7582] mb-4">
              We reserve the right to modify these terms at any time. We will notify users of
              significant changes via email or through the platform. Continued use of the service
              after modifications constitutes acceptance of the updated terms.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">9. Governing Law</h2>
            <p className="text-[#6E7582] mb-4">
              These terms are governed by the laws of Ireland. Any disputes shall be resolved in
              the courts of Ireland.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-[#0F1C2E] mb-4">10. Contact Us</h2>
            <p className="text-[#6E7582] mb-4">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <p className="text-[#6E7582]">
              Email: support@drivewithoutfear.com
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
